import { IFileType } from './Claim';

export const complaintValidationStatuses = {
	RESOLVED: 'RESOLVED',
	FORMAL: 'FORMAL',
	FRLSENT_YES: true,
	CANCELED_MEMBER_REQUEST: 'CANCELED_MEMBER_REQUEST',
	CANCELED_ENTERED_IN_ERROR: 'CANCELED_ENTERED_IN_ERROR',
};

export interface IComplaintPicklist {
	code: string;
	label: string;
}

export interface IComplaintTrackingRow {
	complaintId: number;
	externalClaimId: string;
	claimUUID: string;
	complaintSource: string;
	complaintType: string;
	complaintNotificationDate: string;
	complaintStatus: string;
	rowNum: 0;
}
export interface IComplaintTrackingState {
	rows: IComplaintTrackingRow[];
	complaintDetail: IComplaintTrackingDetail;
	pages: number;
	page: number;
	search: boolean;
	triggerRefresh: boolean;
	complaintReasons: IComplaintPicklist[];
	complaintOutcomes: IComplaintPicklist[];
}

export interface IComplaintTrackingDetail {
	complaintId: number;
	claimUUID: string;
	source: string;
	type: string;
	requestedDate: string;
	status: string;
	reason: string;
	closureDate: string;
	outcome: string;
	frlSent?: boolean;
	frlSentDate: string;
	referralToInsurerDate: string;
	internalNotes: string;
	description: string;
	createdBy: string;
	attachments: IFileType[];
}
